import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const AlertContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  backgroundColor: primitive.$blackOpacity4,
  paddingLeft: '$4',
  paddingRight: '$4',
  paddingTop: '$2',
  paddingBottom: '$2',
  marginTop: '$2',
});

export const AlertText = withTypography({
  variant: 'bodyOne',
  fontSize: 'xs',
  color: primitive.$bbqBrown,
  style: { fontWeight: 'medium' },
});
